import { makeActionCreator } from '../../config/store/utils'
import { batch } from 'react-redux'
import { getKeplerData, getKeplerUrl } from '../../services/keplerServices'

export const GET_MAPBOX = 'GET_MAPBOX'
export const GET_MAPBOX_ERROR = 'GET_MAPBOX_ERROR'
export const GET_MAPBOX_SUCCESS = 'GET_MAPBOX_SUCCESS'
export const onGetMapbox = makeActionCreator(GET_MAPBOX)
export const onGetMapboxError = makeActionCreator(GET_MAPBOX_ERROR, 'payload')
export const onGetMapboxSuccess = makeActionCreator(GET_MAPBOX_SUCCESS, 'payload')
export const onGetMapboxThunk = date => async (dispatch, getState) => {
  dispatch(onGetMapbox())

  try {
    const {
      apis: {
        base: { apiKey, apiName }
      }
    } = getState().auth
    var functionData = { apiKey, apiName }
    if (date) {
      functionData = { apiKey, apiName, datePicker: date }
    }

    const { url } = await getKeplerData(functionData)
    if (url.message === 'No data available for this day.') {
      const urlData = []
      return batch(() => {
        dispatch(onGetMapboxSuccess({ urlData }))
      })
    }
    const { data: urlData } = await getKeplerUrl({
      apiKey,
      apiName,
      url: url.urls[0]
    })

    return batch(() => {
      dispatch(onGetMapboxSuccess({ urlData }))
    })
  } catch (error) {
    return dispatch(onGetMapboxError({ error }))
  }
}
